// test382
(382 && 0);
